
import { useState, useEffect } from 'react';

export default function ProductsPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('featured');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cartItems, setCartItems] = useState<any[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const heroSlides = [
    {
      title: "Premium Mango Products",
      subtitle: "Discover our collection of premium mango desserts crafted with the finest ingredients",
      image: "https://public.readdy.ai/ai/img_res/d9c48a1e82267f37455bf1bc49a3cefc.jpg"
    },
    {
      title: "Family Favorite Desserts",
      subtitle: "Loved by families worldwide for our authentic taste and quality",
      image: "https://readdy.ai/api/search-image?query=Multi-generation%20family%20sharing%20mango%20pudding%20desserts%2C%20grandparents%20and%20grandchildren%20laughing%20together%2C%20thumbs%20up%20gestures%2C%20cozy%20kitchen%20setting%2C%20heartwarming%20family%20moment&width=1200&height=400&seq=2&orientation=landscape"
    },
    {
      title: "Natural & Healthy Choice",
      subtitle: "Made with real mango pulp and natural ingredients your family will love",
      image: "https://readdy.ai/api/search-image?query=Young%20family%20with%20children%20enjoying%20healthy%20mango%20pudding%20snacks%2C%20kids%20giving%20enthusiastic%20thumbs%20up%2C%20outdoor%20picnic%20setting%2C%20fresh%20and%20natural%20lifestyle%2C%20happy%20healthy%20eating&width=1200&height=400&seq=3&orientation=landscape"
    },
    {
      title: "Award-Winning Quality",
      subtitle: "Recognized excellence in taste that brings families together",
      image: "https://readdy.ai/api/search-image?query=Diverse%20families%20celebrating%20with%20mango%20pudding%20desserts%2C%20multiple%20people%20showing%20thumbs%20up%20approval%2C%20festive%20gathering%20atmosphere%2C%20premium%20quality%20celebration%2C%20satisfied%20customers&width=1200&height=400&seq=4&orientation=landscape"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    try {
      const existingCart = typeof window !== 'undefined' ? localStorage.getItem('mangoTreasureCart') : null;
      if (existingCart) {
        setCartItems(JSON.parse(existingCart));
      }
    } catch (error) {
      console.error('Failed to load cart:', error);
    }
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const categories = [
    { id: 'all', name: 'All Products' },
    { id: 'pudding', name: 'Mango Pudding' },
    { id: 'dessert', name: 'Dessert Cups' },
    { id: 'seasonal', name: 'Seasonal' }
  ];

  const products = [
    {
      id: 7,
      name: 'Mango Treasure 6-Pack',
      price: 4.99,
      originalPrice: null,
      category: 'pudding',
      image:
        'https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/10c7623cb512536f303abf7e0ed0e660.png',
      rating: 4.9,
      reviews: 203,
      calories: 105,
      description:
        'Premium 6-pack mango pudding with no preservatives and 100% real mango',
      badge: 'Best Value',
      detailedDescription: 'Our premium 6-pack mango pudding is crafted with the finest ingredients, featuring 100% real mango pulp sourced from tropical farms. Each cup contains no artificial preservatives, colors, or flavors - just pure, natural goodness that your family will love. Perfect for sharing or enjoying throughout the week.',
      ingredients: ['Real Mango Pulp', 'Fresh Cream', 'Natural Sugar', 'Gelatin', 'Vanilla Extract', 'Citric Acid'],
      nutritionFacts: {
        servingSize: '1 cup (125g)',
        calories: 105,
        totalFat: '2g',
        saturatedFat: '1.5g',
        cholesterol: '10mg',
        sodium: '25mg',
        totalCarbs: '20g',
        sugars: '18g',
        protein: '3g'
      },
      allergens: ['Contains: Milk', 'May contain: Eggs'],
      storage: 'Keep refrigerated at 35-40°F. Best consumed within 7 days of opening.'
    },
    {
      id: 8,
      name: 'Mango Treasure 6-Pack Bundle (6 Sets)',
      price: 24.99,
      originalPrice: 29.99,
      category: 'pudding',
      image:
        'https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/10c7623cb512536f303abf7e0ed0e660.png',
      rating: 4.9,
      reviews: 156,
      calories: 105,
      description:
        '6 sets of Mango Treasure 6-pack - perfect for families and bulk buyers',
      badge: 'Family Bundle',
      detailedDescription: 'Perfect for large families or mango pudding enthusiasts! This bundle includes 6 complete sets of our premium 6-pack mango pudding, giving you 36 individual servings of pure mango bliss. Ideal for parties, family gatherings, or stocking up your favorite dessert.',
      ingredients: ['Real Mango Pulp', 'Fresh Cream', 'Natural Sugar', 'Gelatin', 'Vanilla Extract', 'Citric Acid'],
      nutritionFacts: {
        servingSize: '1 cup (125g)',
        calories: 105,
        totalFat: '2g',
        saturatedFat: '1.5g',
        cholesterol: '10mg',
        sodium: '25mg',
        totalCarbs: '20g',
        sugars: '18g',
        protein: '3g'
      },
      allergens: ['Contains: Milk', 'May contain: Eggs'],
      storage: 'Keep refrigerated at 35-40°F. Best consumed within 7 days of opening.'
    },
    {
      id: 9,
      name: 'Mango Treasure 18-Pack Ultimate Bundle',
      price: 59.99,
      originalPrice: 69.99,
      category: 'pudding',
      image:
        'https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/1b8ec7090c81bd06bda5875143aae0b5.png',
      rating: 5.0,
      reviews: 89,
      calories: 105,
      description:
        '18 sets of premium mango pudding - ultimate value with FREE shipping',
      badge: 'Ultimate Value',
      detailedDescription: 'The ultimate mango pudding experience! This massive bundle includes 18 complete sets of our premium 6-pack mango pudding, providing 108 individual servings. Perfect for businesses, large events, or serious mango pudding lovers. Includes FREE 2-day shipping and our best bulk pricing.',
      ingredients: ['Real Mango Pulp', 'Fresh Cream', 'Natural Sugar', 'Gelatin', 'Vanilla Extract', 'Citric Acid'],
      nutritionFacts: {
        servingSize: '1 cup (125g)',
        calories: 105,
        totalFat: '2g',
        saturated: '1.5g',
        cholesterol: '10mg',
        sodium: '25mg',
        totalCarbs: '20g',
        sugars: '18g',
        protein: '3g'
      },
      allergens: ['Contains: Milk', 'May contain: Eggs'],
      storage: 'Keep refrigerated at 35-40°F. Best consumed within 7 days of opening.'
    },
    {
      id: 1,
      name: 'Classic Mango Treasure Pudding',
      price: 12.99,
      originalPrice: 15.99,
      category: 'pudding',
      image:
        'https://readdy.ai/api/search-image?query=Premium%20classic%20mango%20pudding%20in%20elegant%20glass%20cup%20with%20fresh%20mango%20pieces%2C%20professional%20food%20photography%2C%20soft%20lighting%2C%20minimalist%20background%2C%20high%20quality%20dessert%20presentation&width=400&height=400&seq=1&orientation=squarish',
      rating: 4.8,
      reviews: 124,
      calories: 105,
      description:
        'Our signature mango pudding made with premium mango pulp and natural ingredients',
      badge: 'Best Seller',
      detailedDescription: 'Our signature classic mango pudding that started it all! Made with premium mango pulp from the finest tropical mangoes, this creamy delight offers the perfect balance of sweetness and natural mango flavor. Each spoonful delivers a smooth, velvety texture that melts in your mouth.',
      ingredients: ['Premium Mango Pulp', 'Heavy Cream', 'Organic Sugar', 'Gelatin', 'Pure Vanilla', 'Fresh Lime Juice'],
      nutritionFacts: {
        servingSize: '1 cup (150g)',
        calories: 105,
        totalFat: '3g',
        saturatedFat: '2g',
        cholesterol: '15mg',
        sodium: '30mg',
        totalCarbs: '18g',
        sugars: '16g',
        protein: '4g'
      },
      allergens: ['Contains: Milk', 'May contain: Eggs, Tree Nuts'],
      storage: 'Refrigerate immediately. Consume within 5 days for best quality.'
    },
    {
      id: 2,
      name: 'Tropical Mango Delight',
      price: 14.99,
      originalPrice: null,
      category: 'pudding',
      image:
        'https://readdy.ai/api/search-image?query=Tropical%20mango%20pudding%20with%20coconut%20flakes%20and%20tropical%20fruit%20garnish%2C%20vibrant%20colors%2C%20professional%20food%20styling%2C%20elegant%20presentation&width=400&height=400&seq=2&orientation=squarish',
      rating: 4.9,
      reviews: 89,
      calories: 120,
      description:
        'Enhanced with coconut and exotic flavors for an exotic taste experience',
      badge: 'New',
      detailedDescription: 'Transport your taste buds to a tropical paradise! Our Tropical Mango Delight combines the richness of premium mango with exotic coconut flakes and a hint of passion fruit. This innovative flavor profile creates a unique dessert experience that captures the essence of tropical beaches.',
      ingredients: ['Mango Pulp', 'Coconut Cream', 'Coconut Flakes', 'Passion Fruit Extract', 'Natural Sugar', 'Agar', 'Lime Zest'],
      nutritionFacts: {
        servingSize: '1 cup (140g)',
        calories: 120,
        totalFat: '4g',
        saturatedFat: '3g',
        cholesterol: '5mg',
        sodium: '20mg',
        totalCarbs: '22g',
        sugars: '19g',
        protein: '2g'
      },
      allergens: ['Contains: Tree Nuts (Coconut)', 'May contain: Milk'],
      storage: 'Keep chilled. Best enjoyed within 3 days of opening.'
    },
    {
      id: 3,
      name: 'Mango Cream Parfait',
      price: 16.99,
      originalPrice: 19.99,
      category: 'dessert',
      image:
        'https://readdy.ai/api/search-image?query=Layered%20mango%20cream%20parfait%20in%20tall%20glass%20with%20graham%20cracker%20crumbs%2C%20whipped%20cream%20layers%2C%20professional%20dessert%20photography&width=400&height=400&seq=3&orientation=squarish',
      rating: 4.7,
      reviews: 67,
      calories: 145,
      description:
        'Layered parfait with mango pudding, cream, and crunchy graham crackers',
      badge: 'Limited',
      detailedDescription: 'An elegant layered dessert that combines our signature mango pudding with fluffy whipped cream and crunchy graham cracker crumbs. Each layer offers a different texture and flavor, creating a symphony of taste that builds with every spoonful. Perfect for special occasions or when you want to treat yourself.',
      ingredients: ['Mango Pudding', 'Heavy Whipping Cream', 'Graham Crackers', 'Honey', 'Vanilla Extract', 'Cinnamon'],
      nutritionFacts: {
        servingSize: '1 parfait (180g)',
        calories: 145,
        totalFat: '6g',
        saturatedFat: '4g',
        cholesterol: '25mg',
        sodium: '85mg',
        totalCarbs: '24g',
        sugars: '20g',
        protein: '3g'
      },
      allergens: ['Contains: Milk, Wheat', 'May contain: Eggs, Soy'],
      storage: 'Refrigerate immediately. Consume within 2 days for optimal texture.'
    },
    {
      id: 4,
      name: 'Mini Mango Cups (6-pack)',
      price: 18.99,
      originalPrice: null,
      category: 'dessert',
      image:
        'https://readdy.ai/api/search-image?query=Six%20mini%20mango%20pudding%20cups%20arranged%20beautifully%2C%20portion%20control%20desserts%2C%20family%20pack%20presentation%2C%20professional%20product%20photography&width=400&height=400&seq=4&orientation=squarish',
      rating: 4.6,
      reviews: 156,
      calories: 85,
      description:
        'Perfect portion-controlled servings, ideal for families and parties',
      badge: 'Family Pack',
      detailedDescription: 'Perfect for portion control and family sharing! These adorable mini cups contain the same premium mango pudding you love, just in smaller, more manageable sizes. Great for kids\' lunch boxes, party desserts, or when you want just a taste of something sweet without overindulging.',
      ingredients: ['Mango Pulp', 'Light Cream', 'Natural Sweetener', 'Gelatin', 'Natural Flavoring'],
      nutritionFacts: {
        servingSize: '1 mini cup (85g)',
        calories: 85,
        totalFat: '1.5g',
        saturatedFat: '1g',
        cholesterol: '8mg',
        sodium: '15mg',
        totalCarbs: '16g',
        sugars: '14g',
        protein: '2g'
      },
      allergens: ['Contains: Milk', 'May contain: Eggs'],
      storage: 'Keep refrigerated. Best consumed within 5 days.'
    },
    {
      id: 5,
      name: 'Seasonal Mango Berry Fusion',
      price: 15.99,
      originalPrice: null,
      category: 'seasonal',
      image:
        'https://readdy.ai/api/search-image?query=Mango%20pudding%20with%20mixed%20berries%2C%20seasonal%20fruit%20combination%20colorful%20presentation%20fresh%20berry%20garnish%20elegant%20styling&width=400&height=400&seq=5&orientation=squarish',
      rating: 4.8,
      reviews: 43,
      calories: 115,
      description:
        'Seasonal blend of mango with fresh berries for a refreshing twist',
      badge: 'Seasonal',
      detailedDescription: 'A limited-time seasonal creation that marries the tropical sweetness of mango with the tartness of fresh mixed berries. This refreshing combination features strawberries, blueberries, and raspberries swirled into our creamy mango base, creating a colorful and flavorful dessert that celebrates the best of both worlds.',
      ingredients: ['Mango Pulp', 'Fresh Strawberries', 'Blueberries', 'Raspberries', 'Cream', 'Natural Sugar', 'Lemon Juice'],
      nutritionFacts: {
        servingSize: '1 cup (135g)',
        calories: 115,
        totalFat: '2.5g',
        saturatedFat: '1.5g',
        cholesterol: '12mg',
        sodium: '22mg',
        totalCarbs: '24g',
        sugars: '21g',
        protein: '3g'
      },
      allergens: ['Contains: Milk', 'May contain: Tree Nuts'],
      storage: 'Refrigerate immediately. Best enjoyed within 3 days due to fresh berry content.'
    },
    {
      id: 6,
      name: 'Premium Mango Treasure Deluxe',
      price: 22.99,
      originalPrice: 26.99,
      category: 'pudding',
      image:
        'https://readdy.ai/api/search-image?query=Luxury%20mango%20pudding%20in%20premium%20packaging%2C%20gold%20accents%2C%20high-end%20dessert%20presentation%20sophisticated%20styling%20premium%20quality&width=400&height=400&seq=6&orientation=squarish',
      rating: 5.0,
      reviews: 78,
      calories: 125,
      description:
        'Our premium line with enhanced mango flavor and luxury presentation',
      badge: 'Premium',
      detailedDescription: 'The pinnacle of mango pudding excellence! Our Premium Deluxe features the finest Alphonso mangoes, imported directly from India, combined with Madagascar vanilla and organic heavy cream. Each serving is individually crafted and presented in elegant glass containers, making it perfect for special occasions or luxury gifting.',
      ingredients: ['Alphonso Mango Pulp', 'Organic Heavy Cream', 'Madagascar Vanilla', 'Organic Cane Sugar', 'Premium Gelatin', 'Gold Leaf Garnish'],
      nutritionFacts: {
        servingSize: '1 serving (160g)',
        calories: 125,
        totalFat: '5g',
        saturatedFat: '3g',
        cholesterol: '20mg',
        sodium: '35mg',
        totalCarbs: '20g',
        sugars: '18g',
        protein: '4g'
      },
      allergens: ['Contains: Milk', 'Processed in facility that handles Tree Nuts'],
      storage: 'Refrigerate in original glass container. Best consumed within 7 days.'
    }
  ];

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const shipping = subtotal >= 49 ? 0 : 6.99;
  const tax = subtotal * 0.08;
  const total = subtotal + shipping + tax;

  const filteredProducts =
    selectedCategory === 'all'
      ? products
      : products.filter((product) => product.category === selectedCategory);

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    switch (sortBy) {
      case 'price-low':
        return a.price - b.price;
      case 'price-high':
        return b.price - a.price;
      case 'rating':
        return b.rating - a.rating;
      default:
        return 0;
    }
  });

  const addToCart = (product: any) => {
    try {
      const cartItem = {
        id: product.id,
        name: product.name,
        price: product.price,
        originalPrice: product.originalPrice,
        image: product.image,
        quantity: 1,
        calories: product.calories
      };

      const existingCart = typeof window !== 'undefined' ? localStorage.getItem('mangoTreasureCart') : null;
      const cartItems = existingCart ? JSON.parse(existingCart) : [];

      const existingItemIndex = cartItems.findIndex((item: any) => item.id === product.id);

      if (existingItemIndex > -1) {
        cartItems[existingItemIndex].quantity += 1;
      } else {
        cartItems.push(cartItem);
      }

      if (typeof window !== 'undefined') {
        localStorage.setItem('mangoTreasureCart', JSON.stringify(cartItems));
      }

      setCartItems(cartItems);
      alert(`${product.name} added to cart!`);
    } catch (error) {
      console.error('Failed to add to cart:', error);
      alert('Sorry, something went wrong while adding the product to the cart.');
    }
  };

  const openProductModal = (product: any) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const closeProductModal = () => {
    setSelectedProduct(null);
    setIsModalOpen(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-amber-50 to-orange-50">
      {/* Free Shipping Banner */}
      <section className="bg-gradient-to-r from-rose-400 via-pink-400 to-orange-400 text-white py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center space-x-3">
            <i className="ri-truck-line text-2xl"></i>
            <span className="text-lg font-semibold">
              FREE SHIPPING on orders over $50!
            </span>
            <i className="ri-gift-line text-2xl"></i>
          </div>
        </div>
      </section>

      {/* Navigation */}
      <nav className="bg-gradient-to-r from-rose-100/95 via-pink-100/95 to-orange-100/95 backdrop-blur-md shadow-xl sticky top-0 z-50 border-b border-rose-200/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <img
                src="https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/b38163c3c482e773cae655e9f9113361.png"
                alt="Mango Treasure Logo"
                className="h-16 w-auto mr-4 drop-shadow-lg"
              />
              <span
                className="text-3xl font-bold bg-gradient-to-r from-rose-600 via-pink-600 to-orange-600 bg-clip-text text-transparent"
                style={{ fontFamily: '"Pacifico", serif' }}
              >
                Mango Treasure
              </span>
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a
                  className="text-gray-700 hover:text-rose-700 px-4 py-3 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/"
                >
                  Home
                </a>
                <a
                  className="text-rose-700 hover:text-rose-900 px-4 py-3 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/products"
                >
                  Shop Products
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 px-4 py-3 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/story"
                >
                  Our Story
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 px-4 py-3 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/contact"
                >
                  Contact
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 px-4 py-3 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/orders"
                >
                  Track Orders
                </a>
                <a
                  className="bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white px-6 py-3 rounded-full hover:from-rose-600 hover:via-pink-600 hover:to-orange-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg flex items-center space-x-2 font-semibold"
                  href="/cart"
                >
                  <i className="ri-shopping-cart-line text-lg"></i>
                  <span>Cart</span>
                </a>
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={toggleMobileMenu}
                className="bg-white/90 backdrop-blur-sm hover:bg-white text-rose-600 p-3 rounded-lg shadow-lg transition-all duration-300 cursor-pointer border border-rose-100"
              >
                <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1 bg-white/95 backdrop-blur-md rounded-lg mt-2 shadow-xl border border-rose-200/50">
                <a
                  className="text-gray-700 hover:text-rose-700 block px-3 py-2 text-base font-semibold transition-all duration-300 cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Home
                </a>
                <a
                  className="text-rose-700 hover:text-rose-900 block px-3 py-2 text-base font-semibold transition-all duration-300 cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/products"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Shop Products
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 block px-3 py-2 text-base font-semibold transition-all duration-300 cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/story"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Our Story
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 block px-3 py-2 text-base font-semibold transition-all duration-300 cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/contact"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Contact
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 block px-3 py-2 text-base font-semibold transition-all duration-300 cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/orders"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Track Orders
                </a>
                <a
                  className="bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white px-6 py-3 rounded-full hover:from-rose-600 hover:via-pink-600 hover:to-orange-600 transition-all duration-300 cursor-pointer shadow-lg flex items-center space-x-2 font-semibold justify-center mt-4"
                  href="/cart"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <i className="ri-shopping-cart-line text-lg"></i>
                  <span>Cart</span>
                </a>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Carousel */}
      <section className="relative h-96 overflow-hidden">
        <div className="relative w-full h-full">
          {heroSlides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <div
                className="w-full h-full bg-cover bg-center relative"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/50"></div>
                <div className="relative z-10 h-full flex items-center justify-center">
                  <div className="text-center text-white max-w-4xl px-4">
                    <h1 className="text-5xl font-bold mb-4 drop-shadow-lg">{slide.title}</h1>
                    <p className="text-xl mb-8 drop-shadow-md">{slide.subtitle}</p>
                    <button className="bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white px-8 py-3 rounded-full text-lg font-semibold hover:from-rose-600 hover:via-pink-600 hover:to-orange-600 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
                      Shop Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/90 backdrop-blur-sm hover:bg-white text-rose-600 p-3 rounded-full shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer border border-rose-100"
        >
          <i className="ri-arrow-left-line text-xl"></i>
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/90 backdrop-blur-sm hover:bg-white text-rose-600 p-3 rounded-full shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer border border-rose-100"
        >
          <i className="ri-arrow-right-line text-xl"></i>
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentSlide ? 'bg-rose-500 scale-125' : 'bg-white/60 hover:bg-white/80'
              }`}
            />
          ))}
        </div>

        {/* Slide Counter */}
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm text-rose-600 px-3 py-1 rounded-full text-sm font-medium border border-rose-100">
          {currentSlide + 1} / {heroSlides.length}
        </div>
      </section>

      {/* Shipping Info Banner */}
      <div className="bg-gradient-to-r from-rose-400 via-pink-4-400 to-orange-400 text-white py-3">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-sm font-medium">
            <i className="ri-truck-line mr-2"></i>
            FREE 2-Day Shipping on orders $50+ | Orders under $50: $6.99 shipping
          </p>
        </div>
      </div>

      {/* Filters and Sort */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 space-y-4 md:space-y-0">
          <div className="flex flex-wrap gap-2">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white shadow-lg'
                    : 'bg-white/80 backdrop-blur-sm text-rose-700 hover:bg-rose-100/80 border border-rose-200/50'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="px-4 py-2 border border-rose-200 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent pr-8 bg-white/80 backdrop-blur-sm text-rose-700"
          >
            <option value="featured">Featured</option>
            <option value="price-low">Price: Low to High</option>
            <option value="price-high">Price: High to Low</option>
            <option value="rating">Highest Rated</option>
          </select>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-product-shop>
          {sortedProducts.map((product) => (
            <div
              key={product.id}
              className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group border border-rose-100/50"
            >
              <div className="relative">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300 cursor-pointer"
                  onClick={() => openProductModal(product)}
                />
                {product.badge && (
                  <span className="absolute top-3 left-3 bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg">
                    {product.badge}
                  </span>
                )}
                {/* Free Shipping Badge for products $50+ */}
                {product.price >= 50 && (
                  <span className="absolute top-3 right-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center shadow-lg">
                    <i className="ri-truck-line mr-1"></i>
                    FREE SHIPPING
                  </span>
                )}
                {product.price < 50 && (
                  <div className="absolute top-3 right-3 flex space-x-2">
                    <button className="bg-white/90 backdrop-blur-sm hover:bg-white text-rose-600 p-2 rounded-full transition-all cursor-pointer shadow-lg">
                      <i className="ri-heart-line text-sm"></i>
                    </button>
                  </div>
                )}
              </div>
              <div className="p-6">
                <h3 
                  className="text-lg font-semibold text-rose-800 mb-2 line-clamp-2 cursor-pointer hover:text-rose-600 transition-colors"
                  onClick={() => openProductModal(product)}
                >
                  {product.name}
                </h3>
                <p className="text-rose-600 text-sm mb-3 line-clamp-2">
                  {product.description}
                </p>
                <div className="flex items-center mb-3">
                  <div className="flex text-amber-400">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-${
                          i < Math.floor(product.rating) ? 'fill' : 'line'
                        } text-sm`}
                      />
                    ))}
                  </div>
                  <span className="text-rose-600 text-sm ml-2">
                    {product.rating} ({product.reviews})
                  </span>
                </div>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-2">
                    <span className="text-2xl font-bold bg-gradient-to-r from-rose-600 via-pink-600 to-orange-600 bg-clip-text text-transparent">
                      ${product.price}
                    </span>
                    {product.originalPrice && (
                      <span className="text-rose-400 line-through text-sm">
                        ${product.originalPrice}
                      </span>
                    )}
                  </div>
                  <span className="text-rose-500 text-sm">{product.calories} cal</span>
                </div>
                {/* Free Shipping Info for products $50+ */}
                {product.price >= 50 && (
                  <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-3 mb-4">
                    <div className="flex items-center text-green-600 text-sm">
                      <i className="ri-truck-line mr-2"></i>
                      <span className="font-medium">FREE 2-Day Shipping Included!</span>
                    </div>
                  </div>
                )}
                <div className="flex space-x-2">
                  <button
                    onClick={() => openProductModal(product)}
                    className="flex-1 bg-white border-2 border-rose-500 text-rose-500 py-3 rounded-xl font-semibold hover:bg-rose-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    View Details
                  </button>
                  <button
                    onClick={() => addToCart(product)}
                    className="flex-1 bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white py-3 rounded-xl font-semibold hover:from-rose-600 hover:via-pink-600 hover:to-orange-600 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Product Detail Modal */}
        {isModalOpen && selectedProduct && (
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
              <div className="relative">
                <button
                  onClick={closeProductModal}
                  className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm hover:bg-white text-rose-600 p-2 rounded-full transition-all cursor-pointer shadow-lg z-10"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
                
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-8">
                  {/* Product Image */}
                  <div className="relative">
                    <img
                      src={selectedProduct.image}
                      alt={selectedProduct.name}
                      className="w-full h-96 object-cover object-top rounded-2xl shadow-lg"
                    />
                    {selectedProduct.badge && (
                      <span className="absolute top-4 left-4 bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
                        {selectedProduct.badge}
                      </span>
                    )}
                  </div>

                  {/* Product Details */}
                  <div className="space-y-6">
                    <div>
                      <h2 className="text-3xl font-bold text-rose-800 mb-2">{selectedProduct.name}</h2>
                      <div className="flex items-center mb-4">
                        <div className="flex text-amber-400 mr-3">
                          {[...Array(5)].map((_, i) => (
                            <i
                              key={i}
                              className={`ri-star-${
                                i < Math.floor(selectedProduct.rating) ? 'fill' : 'line'
                              } text-lg`}
                            />
                          ))}
                        </div>
                        <span className="text-rose-600 font-medium">
                          {selectedProduct.rating} ({selectedProduct.reviews} reviews)
                        </span>
                      </div>
                    </div>

                    <div className="flex items-center space-x-4">
                      <span className="text-4xl font-bold bg-gradient-to-r from-rose-600 via-pink-600 to-orange-600 bg-clip-text text-transparent">
                        ${selectedProduct.price}
                      </span>
                      {selectedProduct.originalPrice && (
                        <span className="text-rose-400 line-through text-xl">
                          ${selectedProduct.originalPrice}
                        </span>
                      )}
                      <span className="text-rose-500 text-lg">{selectedProduct.calories} cal</span>
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold text-rose-800 mb-2">Description</h3>
                      <p className="text-rose-600 leading-relaxed">{selectedProduct.detailedDescription}</p>
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold text-rose-800 mb-2">Ingredients</h3>
                      <div className="flex flex-wrap gap-2">
                        {selectedProduct.ingredients.map((ingredient: string, index: number) => (
                          <span
                            key={index}
                            className="bg-rose-100 text-rose-700 px-3 py-1 rounded-full text-sm"
                          >
                            {ingredient}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold text-rose-800 mb-2">Nutrition Facts</h3>
                      <div className="bg-rose-50 rounded-lg p-4 space-y-2">
                        <div className="flex justify-between">
                          <span className="text-rose-700">Serving Size:</span>
                          <span className="text-rose-800 font-medium">{selectedProduct.nutritionFacts.servingSize}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-rose-700">Calories:</span>
                          <span className="text-rose-800 font-medium">{selectedProduct.nutritionFacts.calories}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-rose-700">Total Fat:</span>
                          <span className="text-rose-800 font-medium">{selectedProduct.nutritionFacts.totalFat}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-rose-700">Total Carbs:</span>
                          <span className="text-rose-800 font-medium">{selectedProduct.nutritionFacts.totalCarbs}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-rose-700">Protein:</span>
                          <span className="text-rose-800 font-medium">{selectedProduct.nutritionFacts.protein}</span>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold text-rose-800 mb-2">Allergen Information</h3>
                      <div className="space-y-1">
                        {selectedProduct.allergens.map((allergen: string, index: number) => (
                          <p key={index} className="text-rose-600 text-sm">{allergen}</p>
                        ))}
                      </div>
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold text-rose-800 mb-2">Storage Instructions</h3>
                      <p className="text-rose-600 text-sm">{selectedProduct.storage}</p>
                    </div>

                    {selectedProduct.price >= 50 && (
                      <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4">
                        <div className="flex items-center text-green-600">
                          <i className="ri-truck-line mr-2 text-lg"></i>
                          <span className="font-medium">FREE 2-Day Shipping Included!</span>
                        </div>
                      </div>
                    )}

                    <button
                      onClick={() => {
                        addToCart(selectedProduct);
                        closeProductModal();
                      }}
                      className="w-full bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white py-4 rounded-xl text-lg font-semibold hover:from-rose-600 hover:via-pink-600 hover:to-orange-600 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                    >
                      Add to Cart - ${selectedProduct.price}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Footer */}
        <footer className="bg-gradient-to-r from-rose-900 via-pink-900 to-orange-900 text-white py-12 mt-20 rounded-t-3xl">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div>
                <div className="flex items-center mb-4">
                  <img
                    src="https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/b38163c3c482e773cae655e9f9113361.png"
                    alt="Mango Treasure Logo"
                    className="h-12 w-auto mr-3 drop-shadow-lg"
                  />
                  <span
                    className="text-xl font-bold"
                    style={{ fontFamily: '"Pacifico", serif' }}
                  >
                    Mango Treasure
                  </span>
                </div>
                <p className="text-rose-200 mb-4">
                  Premium mango desserts crafted with love and the finest ingredients.
                </p>
                <div className="flex space-x-4">
                  <a href="#" className="text-rose-200 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-facebook-fill text-xl"></i>
                  </a>
                  <a href="#" className="text-rose-200 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-xl"></i>
                  </a>
                  <a href="#" className="text-rose-200 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-twitter-line text-xl"></i>
                  </a>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
                <ul className="space-y-2">
                  <li><a href="/" className="text-rose-200 hover:text-white transition-colors cursor-pointer">Home</a></li>
                  <li><a href="/products" className="text-rose-200 hover:text-white transition-colors cursor-pointer">Products</a></li>
                  <li><a href="/story" className="text-rose-200 hover:text-white transition-colors cursor-pointer">Our Story</a></li>
                  <li><a href="/contact" className="text-rose-200 hover:text-white transition-colors cursor-pointer">Contact</a></li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Customer Service</h3>
                <ul className="space-y-2">
                  <li><a href="/orders" className="text-rose-200 hover:text-white transition-colors cursor-pointer">Track Your Order</a></li>
                  <li><a href="#" className="text-rose-200 hover:text-white transition-colors cursor-pointer">Shipping Info</a></li>
                  <li><a href="#" className="text-rose-200 hover:text-white transition-colors cursor-pointer">Returns</a></li>
                  <li><a href="#" className="text-rose-200 hover:text-white transition-colors cursor-pointer">FAQ</a></li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
                <div className="space-y-2 text-rose-200">
                  <p>
                    <i className="ri-phone-line mr-2"></i>
                    <a href="tel:+1-571-531-8278" className="hover:text-white transition-colors cursor-pointer">
                      (571) 531-8278
                    </a>
                  </p>
                  <p>
                    <i className="ri-mail-line mr-2"></i>
                    <a href="mailto:support@mangotreasure.com" className="hover:text-white transition-colors cursor-pointer">
                      support@mangotreasure.com
                    </a>
                  </p>
                  <p><i className="ri-map-pin-line mr-2"></i>#303, 1952 Gallows Rd, Vienna, VA, United States</p>
                </div>
              </div>
            </div>
            <div className="border-t border-rose-800 mt-8 pt-8 text-center text-rose-200">
              <p>&copy; 2024 Mango Treasure. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
